/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { NetworkError } from "@apollo/client/errors";

function statusCode(error?: NetworkError) {
    if (error && "statusCode" in error) {
        return error.statusCode;
    }

    return undefined;
}

export default class NetworkErrorUtil {
    public static isUnauthorized(error?: NetworkError): boolean {
        return statusCode(error) === 401;
    }

    public static isBadRequest(error?: NetworkError): boolean {
        return statusCode(error) === 400;
    }
}
